<template>
  <div id="page404">
    <!-- header part -->
    <my-header></my-header>
    <!-- article mian part -->
    <div id="article-main">
      <div class="container">
        <!-- catalog left and right part -->
        <div class="w-100 p-5 text-center">
          <img src="/static/images/404/404.png" width="50%" height="50%" />
        </div>
      </div>
    </div>
    <!-- footer part -->
    <my-footer></my-footer>
  </div>
</template>
<script>


import header from '@/views/header/header';
import footer from '@/views/footer/footer';


export default {
  name: 'page404',
  components: {
    'my-header': header,
    'my-footer': footer,
  },
  data() {
    return {
      // // parent: null, // 左侧父栏目
      // parent: [{'classifyName':''}],
      // // childrens: null, // 左侧子栏目
      // childrens: [{'classifyName':''}],
      // // currClassify: null, // 当前点击栏目
      // currClassify: [{'classifyName':''}],
      // artId : null,
      // articles: {'title':'','createTime':'2020-12-22 8:30:10','content':''},
      // // articles: null,
      // cId: localStorage.getItem('cId'),
      // pId: localStorage.getItem('pId'),

    }
  },
  created() {
    // const artId = this.$route.params.artId;
    // this.artId = artId;
  },
  mounted () {
    // let that = this;
    // 栏目列表
    // axios.get(that.global.apiUrl + '/api/cms/classify/listAllByParent/' + that.pId)
    //   .then(function (response) {
    //           if (response.data.success) {
    //               that.parent = response.data.data.parent;
    //               that.childrens = response.data.data.childrens;
    //               for (var i = 0; i < that.childrens.length; i++) {
    //                   if(that.childrens[i].classifyId == that.cId) {
    //                       that.currClassify = that.childrens[i];
    //                       break;
    //                   }
    //               }
    //           }
    //       }
    //   ).catch(function (error) { // 请求失败处理
    //   console.log(error);
    // });

    // 加载文章
    // that.loadArticle();


  },
  methods:{
    // // 加载文章
    // loadArticle: function () {
    //   var that = this;
    //   // 获取文章
    //   axios.get(that.global.apiUrl + '/web/article?id='+that.artId)
    //     .then(function (response) {
    //       if (response.data.success > 0 && response.data.data != null) {
    //         that.articles = response.data.data;
    //       }else {
    //         that.$router.push({ name: '404'});
    //       }
    //   });
    // },
    // showMore:function(pId,cId){
    //     // console.log('---------pId:' + pId);
    //     localStorage.setItem('pId', pId);
    //     localStorage.setItem('cId', cId);

    //     // console.log('cId2:---' + localStorage.getItem('cId'));
    //     window.location.href='list.html';
    // },
    // getPartTimeForDate:function (val) {
    //   var timearr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
    //   var timestr = ""+ Number(timearr[1])+ "月" + timearr[2]+"日";
    //   return timestr;
    // },
    // getPartTimeYmd: function (val) {
    //   //let ti = val.split(' ');
    //   var timearr = val.split(" ");
    //   var timestr = ""+ timearr[0];
    //   return timestr;
    // }
  }
};

// $(document).ready(function() { });



</script>

<style>
  .catalog-hd {
    background-color: #8B0000;
  }
  .catalog-list-group {
    border-top: 0!important;
    border-radius: 0;
  }
  .catalog-list-group li:hover {
    /* background-color: #8B0000; */
    background-color: #0069D9;
    color: #FFFFFF;
  }
  .catalog-list-group li:hover a {
    color: #FFFFFF;
    text-decoration: none;
  }
  .breadcrumb {
    /* background-color: #FFFFFF; */
    font-size: 14px;
    border-bottom: 1px #ccc solid;
    border-radius: 0;
  }
  .details-title {
    font-size: 18px;
    font-weight: bold;
  }
  .details-intro {
    font-size: 12px;
    border-bottom: 1px #ccc dotted;
  }
  .details-content {
    border-bottom: 1px #ccc dotted;
  }
  .prev-next {
    font-size: 12px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/views/error/404.vue